import {TaskField} from '../../../../../../../constants/tasks';
import {QuestionDetails} from '../../../../../types';
import {getOperatoriesForFilters} from '../../../../../../../api/operatories';
import {getAllTreatments} from '../../../../../../../api/treatments';
import {OperatoryListProps, OptionsProp, TreatmentResponseProps} from '../../../../../../../constants/types';

const operatoriesToOptions = (
    operatories: OperatoryListProps[] = []
): OptionsProp[] => operatories?.map(({id, number, desc}) => ({
  value: id.toString(),
  label: number ? number.toString() : desc
})) || [];

const treatmentsToOptions = (
    treatments: TreatmentResponseProps[] = []
): OptionsProp[] =>
  treatments?.map(({rootId, displayName}) => ({
    value: rootId.toString(),
    label: displayName
  })) || [];

export const getSpecificQuestionPropsByType = (
    type: TaskField,
    details: Nullable<QuestionDetails>
) => {
  const {options, placeholder, default: defaultValue} = details || {};

  switch (type) {
    case TaskField.SELECT:
    case TaskField.MULTI_SELECT:
      return {
        options: options || []
      };
    case TaskField.OPERATORY_SELECT:
      return {
        options: options || [],
        loadOptionsPromise: getOperatoriesForFilters,
        formatOptions: operatoriesToOptions
      };
    case TaskField.TREATMENT_SELECT:
      return {
        options: options || [],
        loadOptionsPromise: getAllTreatments,
        formatOptions: treatmentsToOptions
      };
    case TaskField.TEXT:
      return {
        placeholder: placeholder || '',
        defaultValue: defaultValue || ''
      };
    case TaskField.DATE_TIME:
      return {
        now: defaultValue || '',
        placeholder: placeholder || ''
      };
    case TaskField.DATE:
      return {
        now: defaultValue || '',
        placeholder: placeholder || ''
      };
    default:
      return {};
  }
};
